import { AI_READING_TYPE } from "./ai_reading_type.js";

//标题value:label的map
const getCompareTitleMap = () => {
  let titleMap = {};
  AI_READING_TYPE.forEach((item) => {
    titleMap[item.value] = item.label;
  });
  return titleMap;
};
const COMPARE_TITLE_MAP = getCompareTitleMap();

//标题是否可见
const COMPARE_TITLE_VISIBLE = {
  SHOW: 1,
  HIDE: 2,
};
//标题类型
const COMPARE_TITLE_TYPE = {
  SYSTEM: 1,
  CUSTOM: 2,
};

//系统默认的行高和列宽
const SYSTEM_STYLE = {
  WIDTH: "310",
  HEIGHT: "156",
};

//可设置的类型
const SETTING_TYPE = {
  LINE_HEIGHT: 1,
  COLUMN_WIDTH: 2,
  FIT_HEIGHT: 3,
  DEFAULT: 4,
};
//行高类型：1.自适应/2.非自适应
const LINE_HEIGHT_TYPE = {
  FIT: 1,
  NOFIT: 2,
};

export {
  COMPARE_TITLE_MAP,
  COMPARE_TITLE_VISIBLE,
  COMPARE_TITLE_TYPE,
  SYSTEM_STYLE,
  SETTING_TYPE,
  LINE_HEIGHT_TYPE,
};
